Vue.component('side-buttons', {
    template: templates.sideButtons,
    data() {
        return {
          // Add any local data properties here
        }
    },
    mounted() {
        const c = this;
        c.$root.$on('quest', data => {
          console.log('quest');
        })

    },
    methods: {
      openEvents(){
        const c = this

        c.$root.$emit('open-events-modal');
      },
      openAnnouncement(){
        const c = this

        c.$root.$emit('open-announcement-modal');
      }
    }
})